import { FC } from "react";
import { Button, Modal, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useRankingSnapshotStore } from "../store/rankingSnapshotStore";

const DELETE_RANKING_SNAPSHOT_TOAST_KEY = "deleteRankingSnapshotKey";

const DeleteRankingSnapshot: FC<{
  open: boolean;
  projectSlug: string;
  rankingProjectId: number;
  snapshotId: number | null;
  executedAtLabel: string;
  onClose: () => void;
}> = ({
  open,
  projectSlug,
  rankingProjectId,
  snapshotId,
  executedAtLabel,
  onClose,
}) => {
  const deleteSnapshot = useRankingSnapshotStore(
    (state) => state.deleteSnapshot,
  );

  const doDeleteRankingSnapshot = async () => {
    if (!snapshotId) {
      return;
    }
    onClose();
    message.open({
      key: DELETE_RANKING_SNAPSHOT_TOAST_KEY,
      content: "Deleting ranking snapshot...",
      type: "loading",
      duration: 0,
    });
    try {
      await deleteSnapshot(projectSlug, rankingProjectId, snapshotId);
      message.success("Ranking snapshot deleted successfully.");
    } catch (error: any) {
      const backendMessage = error?.error?.response?.data?.message;
      const contentMessage =
        !backendMessage && error instanceof Error ? error.message : null;
      message.error(
        backendMessage ||
          contentMessage ||
          "Failed to delete ranking snapshot.",
      );
    } finally {
      message.destroy(DELETE_RANKING_SNAPSHOT_TOAST_KEY);
    }
  };

  return (
    <Modal
      className="confirmationModal"
      title={<>Delete Ranking Snapshot</>}
      centered
      open={open}
      destroyOnClose
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          onClick={() => {
            doDeleteRankingSnapshot().catch(console.error);
          }}
        >
          Delete
        </Button>,
      ]}
    >
      <div className="notificationTxtWrap">
        <ExclamationCircleFilled
          className="mediumColor notificationIcon"
          aria-hidden
          aria-label=""
        />
        <div className="notificationTxt">
          <p>
            Are you sure you want to delete the snapshot from{" "}
            <strong>{executedAtLabel}</strong>? This execution's saved
            results will be permanently deleted.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRankingSnapshot;
